type AccountIdentity = {
  accountDisplayName?: string;
  email?: string;
  firstName?: string;
  id?: string;
  lastName?: string;
};

export const getAccountDisplayName = (account: AccountIdentity): string => {
  const accountDisplayName = account.accountDisplayName?.trim();
  if (accountDisplayName) {
    return accountDisplayName;
  }

  const fullName = [account.firstName, account.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();
  if (fullName) {
    return fullName;
  }

  return account.email || account.id || '';
};
